// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetPagedHydrantListRequestModel from '../../model/get-paged-hydrant-list-request-model';
import GetPagedHydrantListRequestDTO from '../dto/get-paged-hydrant-list-request-dto';
import dtoSchema from '../schemas/get-paged-hydrant-list-request-schema';

export default abstract class GetPagedHydrantListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetPagedHydrantListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.fireDepartmentId = data.fireDepartmentId;
      this.number = data.number;
      this.address = data.address;
      this.location = data.location;
      this.remark = data.remark;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  fireDepartmentId?: number;
  /**
  * @type {int32}
  */
  number?: number;
  /**
  */
  address?: string;
  /**
  */
  location?: string;
  /**
  */
  remark?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetPagedHydrantListRequestDTO>): GetPagedHydrantListRequestModel;
  static toModel(dto: DeepPartial<GetPagedHydrantListRequestDTO> | undefined | null): GetPagedHydrantListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetPagedHydrantListRequestDTO> | undefined | null): GetPagedHydrantListRequestModel | undefined {
    return dto ? new GetPagedHydrantListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetPagedHydrantListRequestModel> | GetPagedHydrantListRequestModel): GetPagedHydrantListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      fireDepartmentId: unwrapped.fireDepartmentId,
      number: unwrapped.number,
      address: unwrapped.address,
      location: unwrapped.location,
      remark: unwrapped.remark,
      searchCriteria: unwrapped.searchCriteria,
    } as GetPagedHydrantListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetPagedHydrantListRequestModel, can not map to GetPagedHydrantListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
